@if (componentData.data$ | async; as component) {
  <div class="container">
    <div
      boelsDynamicContentLinkHandler
      class="text-component row"
      [class.pb-0]="component.removeBottomSpacing | safeCheck"
    >
      <div
        class="left col-lg-6"
        [innerHTML]="component.leftContent | prepareHtml"
      ></div>
      <div
        class="right col-lg-6"
        [innerHTML]="component.rightContent | prepareHtml"
      ></div>
    </div>
  </div>
}
